export default "__VITE_ASSET__DaV_68Bt__"